import i18n from '@/i18n'
import { mode } from 'webconfig'

export const IsDevAndLocal = () => {
    try {
        let isLocal = window && window.origin ? window.origin.includes('localhost') : false
        return mode === "dev" || isLocal
    }
    catch (e) {
        return false
    }
}

/**
 * 유저 소스 업로드 정책
 */
export const USER_SOURCE_UPLOAD_POLICY = {
    FormatList: {
        Image: ['.png', '.jpg', '.jpeg', '.webp'],// 'tiff', 'tif' 1차 제외 확장자
        Video: ['.mp4', '.mov']//'avi', 'webm', 'mpg', 'mkv', 'flv', '3gp', 'ogv', 'wmv' 1차 제외 확장자
    },
    InputElementAccept: {
        Image: "image/png, image/jpg, image/jpeg, image/webp",
        Video: "video/mp4, video/mov, .mkv" // , video/webm, .3gp
    },
    // 지원 형식
    FormatRegex: {
        Image: /.png|.jpg|.jpeg|.webp/i,
        Video: /.mp4|.mov|.mkv/i // |.webm|.3gp
    },
    // 용량 제한
    LimitSize: {
        Thumbnail: 1024 * 1024 * 5, // 5mb
        Image: 1024 * 1024 * 20, // 20mb
        Video: 1024 * 1024 * 200 // 200mb
    },
    // 클라우드에 업로드할 파일 타입
    CloudUploadType: {
        Image: /.tiff|.tif/i,
        Video: /.avi|.webm|.mpg|.mkv|.flv|.3gp|.ogv|.wmv/i
    },
    // 파일 최대 업로드/선택 개수
    UploadMaxLegth: {
        Upload: 10,
        Encoding: 10,
    },
    PolicyType: {
        LIMIT: "LimitSize",
        FORMAT: "FilfFormat",
        CODEC: "Codec",
    }

}

/**
 * 에디터 관련 정책
 */
export const EDITOR_POLICY = {
    AutoSave: {
        SaveInterval: 1000 * 60 * 20, // 저장 주기 20분(ms)
        CheckInterval: 5000 // 체크 주기 5초(ms)
    }
}

export const APP_STORE_DEEP_LINK = "https://onelink.to/ae7kv4"

export const GetBusinessTemplateCategory = () => {
    return {
        All:                    { label: i18n.t("categoryfiltering.businesscategory.entire"), key: "전체" },
        Beauty:                 { label: i18n.t("categoryfiltering.businesscategory.beauty_commercial"), key: "뷰티" },
        Fashion:                { label: i18n.t("categoryfiltering.businesscategory.fashion_commercial"), key: "패션" },
        Ecommerce_Shopping:     { label: i18n.t("categoryfiltering.businesscategory.ecommerce_shopping mall"), key: "E커머스/쇼핑몰" },
        Cafe_Food_Bakery:       { label: i18n.t("categoryfiltering.businesscategory.cafe_food_bakery_ad"), key: "카페/음식/베이커리" },
        Lodging_Trabel_Leisure: { label: i18n.t("categoryfiltering.businesscategory.lodging_travel_leisure"), key: "숙박/여행/레저" },
        Health_Sports:          { label: i18n.t("categoryfiltering.businesscategory.health_sports"), key: "헬스/스포츠" },
        Realestate:             { label: i18n.t("categoryfiltering.businesscategory.realestate"), key: "부동산" },
        EduAcademy:             { label: i18n.t("categoryfiltering.businesscategory.edu_academy"), key: "교육 서비스" },
        Leaflet:                { label: i18n.t("categoryfiltering.businesscategory.leaflet"), key: "전단지" },
        DynamicShorts:          { label: i18n.t("categoryfiltering.businesscategory.dynamic_shorts"), key: "다이나믹 쇼츠" },
        Medical_Professional:   { label: i18n.t("categoryfiltering.businesscategory.medical_professional"), key: "병원/전문직" },
        Event_Promo:            { label: i18n.t("categoryfiltering.businesscategory.event_promo"), key: "이벤트/홍보" },
        VLog:                   { label: i18n.t("categoryfiltering.businesscategory.vlog"), key: "VLog" },
        YoutubeTitle:           { label: i18n.t("categoryfiltering.businesscategory.youtube_title"), key: "Youtube 타이틀" },
        Others:                 { label: i18n.t("categoryfiltering.businesscategory.others"), key: "기타" }
    }
}

export const GetStyleTemplateCategory = () => {
    return {
        All:            { label: i18n.t("categoryfiltering.stylecategory.entire"), key: "전체" },
        Dynamic:        { label: i18n.t("categoryfiltering.stylecategory.dynamic"), key: "역동적" },
        Cheerful:       { label: i18n.t("categoryfiltering.stylecategory.cheerful"), key: "경쾌한" },
        Sentimental:    { label: i18n.t("categoryfiltering.stylecategory.sentimental"), key: "감성적" },
        Simple:         { label: i18n.t("categoryfiltering.stylecategory.simple"), key: "심플한" },
        Vintage:        { label: i18n.t("categoryfiltering.stylecategory.vintage"), key: "빈티지" },
        BlackWhite:     { label: i18n.t("categoryfiltering.stylecategory.black_white"), key: "흑백" },
        Colorful:       { label: i18n.t("categoryfiltering.stylecategory.colourful"), key: "컬러풀한" },
        Cute:           { label: i18n.t("categoryfiltering.stylecategory.cute"), key: "귀여운" },
        Season:         { label: i18n.t("categoryfiltering.stylecategory.season"), key: "계절감" },
        SubtitleBased:  { label: i18n.t("categoryfiltering.stylecategory.subtitle_based"), key: "자막위주" }
    }
}

export const PRODUCT_GRADE_TYPE = {
    BASIC: "Basic",
    STANDARD: "Standard",
    PRO: "Pro",
    ACADEMY: "Academy"
}

export const PRODUCT_TYPE = {
    SUBSCRIPTION_PAYMENT: "SubscriptionPayment",
    TERM_PAYMENT: "TermPayment",
    ISSUE_COUPON: "IssueCoupon",
    WATERMARK_PAYMENT: "WatermarkPayment",
    PER_PAYMENT: "PerPayment"
}

export const RENDER_STATE = {
    EMPTY: 'Empty',
    WAITING: 'Waiting',
    RENDERING: 'Rendering',
    FINISH: 'Finish',
    ERROR: 'Error'
}

export const POINT_UI_EXPIRED_DATE = mode === "stage" ? new Date("2023-11-30T15:00:00.000Z") : new Date("2023-11-01T15:00:00.000Z") ;

export const AI_UI_UPDATE_DATE =
  mode === "stage"
    ? new Date("2024-11-10T15:00:00.000Z")
    : new Date("2024-10-20T15:00:00.000Z");  

export const GetVideoStoragePeriodMonth = () => new Date() >= new Date("2024-11-17T15:00:00.000Z") ? 1 : 6;

export const GetIsAiUiUpdate = () => new Date() >= AI_UI_UPDATE_DATE;

export const CREDIT_PRODUCT_TYPE = {
  // [ AI Tools ]
  REMOVE_BG: "RemoveBackground", // 배경제거
  GENERATE_BG: "GenerateBackground", // 배경생성 (deprecated)
  GENERATE_BG_TURBO: "GenerateBackgroundTurbo", // 배경생성(터보) (deprecated)
  UPSCALING: "Upscaling", // 화질개선
  EXTEND_IMG: "ExtendImage", // 이미지확장
  ERASE_OBJ: "EraseObject", // 개체제거
  GENERATE_COPY: "GenerateCopy", // Copy생성
  GENERATE_BG_RELIGHT: "GenerateBackgroundRelight", // 배경생성(리라이트)
  INPAINT: "Inpaint", // 그려넣기
  SKETCH_TO_IMAGE: "SketchToImage", // 스케치 투 이미지 생성

  // [ AI Studio ]
  IMAGE_TO_VIDEO: "ImageToVideo", // 이미지 투 비디오 생성 (Standard)
  IMAGE_TO_VIDEO_PRO: "ImageToVideoPro", // 이미지 투 비디오 생성(Pro)

  // [ URL to Video ]
  YOUTUBE_URL_TO_VIDEO: "YoutubeUrlToVideo", // 유튜브 URL 투 비디오 생성
  PRODUCT_URL_TO_VIDEO: "ProductUrlToVideo", // 상품 URL 투 비디오 생성

  // [ 3rd Party ]
  GETTYIMAGES_IMG: "GettyImagesImage", // GettyImages 이미지
  GETTYIMAGES_VIDEO: "GettyImagesVideo", // GettyImages 비디오
};

export const MYSOURCE_FILE_TYPE = {
    IMAGE: "Image",
    VIDEO: "Video",
    TEXT: "Text",
    UNKNWON: "Unknown"
}

export const MYSOURCE_SOURCE_TYPE = {
  VIDEO: "Video",
  IMAGE: "Image",
  TEXT: "Text",
  STOCK_IMAGE: "StockImage",
  STOCK_VIDEO: "StockVideo",
};

export const MYSOURCE_PROVIDER_TYPE = {
  USER: "User",
  PIXABAY: "Pixabay",
  PEXELS: "Pexels",
  UPSPLASH: "Upsplash",
  GETTYIMAGES: "Gettyimages",
};

export const MYSOURCE_STATE_TYPE = {
  WAITING: "Waiting",
  ENCODING: "Encoding",
  FINISH: "Finish",
  ERROR: "Error",
};

export const CREDIT_REQUESTER_TYPE = {
  USER: "User",
  SYSTEM: "System",
  ADMIN: "Admin",
};

export const getCreditProductInfo = (credit, creditProductType) => {
  if (!credit || !credit.list || !credit.list.find(v => v.type === creditProductType)) return null;
  return credit.list.find(v => v.type === creditProductType);
}

export const getCreditPrice = (credit, creditProductType) => {
	if (!credit || !credit.list || !credit.list.find(v => v.type === creditProductType)) return null
	return credit.list.find(v => v.type === creditProductType).credit
}

export const AI_POLICY = {
    LimitSize: {
        Image: 1024 * 1024 * 20, // 20mb
    },
    LimitResolution: {
        Image: {
            width: 4096,
            height: 4096,
        }
    },
    UpscalingLimitResolution: {
        Image: {
            width: 1536,
            height: 1536,
        }
    }
}

// TO-DO : (Deprecated) AI_POLICY.LimitResolution 사용
export const AI_MAX_IMAGE_SIZE = {
  width: 2048,
  height: 2048,
};

// TO-DO : (Deprecated) AI_POLICY.UpscalingLimitResolution 사용
export const AI_UPSCALING_MAX_IMAGE_SIZE = {
  width: 1536,
  height: 1536,
}

export const CANVAS_SIZE = {
    width: 420,
    height: 420,
}

export const SMALL_CANVAS_SIZE = {
    width: 380,
    height: 380,
}

export const THIRD_PART_TYPES = {
    PIXABAY: "Pixabay",
    PEXELS: "Pexels",
    UNSPLASH: "Unsplash",
    GETTY: "Getty Images"
}

export const GetProductCategory = () => {
    return [
        "-",
        i18n.t("common.category.fashion.clothing"),
        i18n.t("common.category.beauty.cosmetics"),
        i18n.t("common.category.tech.electronics"),
        i18n.t("common.category.food.dining"),
        i18n.t("common.category.home.living"),
        i18n.t("common.category.sports.outdoor"),
        i18n.t("common.category.education.academy"),
        i18n.t("common.category.travel.leisure"),
        i18n.t("common.category.health.medical"),
        i18n.t("common.category.life.service"),
        i18n.t("common.category.hobby.self.improvement"),
        i18n.t("common.category.finance.professional"),
        i18n.t("common.category.real.estate"),
        i18n.t("common.category.baby.kids"),
        i18n.t("common.category.pet"),
    ]
}

export const GetEmotionCategory = () => {
    return [
        "-", 
        i18n.t("common.emotion.excitement"),
        i18n.t("common.emotion.trust"),
        i18n.t("common.emotion.urgency"),
        i18n.t("common.emotion.curiosity"),
        i18n.t("common.emotion.happiness"),
    ]
}

export const GetPurposeCategory = () => {
    return [
        "-", 
        i18n.t("common.purpose.brand.awareness"),
        i18n.t("common.purpose.product.promotion"),
        i18n.t("common.purpose.event.promotion")
    ]
}

export const GetLengthCategory = () => {
    return [
        "-", 
        i18n.t("common.length.short"),
        i18n.t("common.length.medium"),
        i18n.t("common.length.long")
    ]
}

export const GetAgeCategory = () => {
    return [
        "-", 
        i18n.t("common.age.teens"),
        i18n.t("common.age.twenties"),
        i18n.t("common.age.thirties"),
        i18n.t("common.age.forty.plus"),
    ]
}

export const GetGenderCategory = () => {
    return [
        "-", 
        i18n.t("common.gender.male"),
        i18n.t("common.gender.female"),
        i18n.t("common.gender.neutral")
    ]
}

export const GetSocialMediaCategory = () => {
    return [
        '-',
        i18n.t("common.social.media.instagram"),
        i18n.t("common.social.media.facebook"),
        i18n.t("common.social.media.twitter"),
        i18n.t("common.social.media.tiktok")
    ]
}

export const GetMediaTypeCategory = () => {
    return [
        '-',
        i18n.t("common.media.type.image.banner"),
        i18n.t("common.media.type.video.short"),
    ]
}

export const GetLanguageCategory = () => {
    return [
        i18n.t("common.language.auto"),
        i18n.t("common.language.korean"),
        i18n.t("common.language.english"),
        i18n.t("common.language.japanese"),
    ]
}

export const GetProductDetailCategory = () => {
    return {
        "-":[],
        [i18n.t("common.category.fashion.clothing")]: [
            '-',
            i18n.t("common.category.detail.fashion.top"),
            i18n.t("common.category.detail.fashion.pants"),
            i18n.t("common.category.detail.fashion.dress.skirt"),
            i18n.t("common.category.detail.fashion.outerwear"),
            i18n.t("common.category.detail.fashion.shoes"),
            i18n.t("common.category.detail.fashion.bags"),
            i18n.t("common.category.detail.fashion.accessories"),
            i18n.t("common.category.detail.fashion.underwear"),
          ],
          [i18n.t("common.category.beauty.cosmetics")]: [
            '-',
            i18n.t("common.category.detail.beauty.skincare"),
            i18n.t("common.category.detail.beauty.bodycare"),
            i18n.t("common.category.detail.beauty.haircare"),
            i18n.t("common.category.detail.beauty.suncare"),
            i18n.t("common.category.detail.beauty.makeup"),
            i18n.t("common.category.detail.beauty.cleansing"),
            i18n.t("common.category.detail.beauty.nail"),
            i18n.t("common.category.detail.beauty.perfume.diffuser"),
            i18n.t("common.category.detail.beauty.oralcare"),
            i18n.t("common.category.detail.beauty.hygiene"),
            i18n.t("common.category.detail.beauty.tools"),
            i18n.t("common.category.detail.beauty.menscare"),
          ],
          [i18n.t("common.category.tech.electronics")]: [
            '-',
            i18n.t("common.category.detail.tech.home.appliances"),
            i18n.t("common.category.detail.tech.kitchen.appliances"),
            i18n.t("common.category.detail.tech.electronics"),
            i18n.t("common.category.detail.tech.wearables"),
            i18n.t("common.category.detail.tech.audio.video"),
          ],
          [i18n.t("common.category.food.dining")]: [
            '-',
            i18n.t("common.category.detail.food.fresh"),
            i18n.t("common.category.detail.food.processed"),
            i18n.t("common.category.detail.food.beverage"),
            i18n.t("common.category.detail.food.dining.experience"),
          ],
          [i18n.t("common.category.home.living")]: [
            '-',
            i18n.t("common.category.detail.home.furniture"),
            i18n.t("common.category.detail.home.decor"),
            i18n.t("common.category.detail.home.bedding"),
            i18n.t("common.category.detail.home.kitchenware"),
            i18n.t("common.category.detail.home.storage"),
            i18n.t("common.category.detail.home.essentials"),
          ],
          [i18n.t("common.category.sports.outdoor")]: [
            '-',
            i18n.t("common.category.detail.sports.equipment"),
            i18n.t("common.category.detail.outdoor.gear"),
            i18n.t("common.category.detail.activewear"),
            i18n.t("common.category.detail.fitness"),
          ],
          [i18n.t("common.category.education.academy")]: [
            '-',
            i18n.t("common.category.detail.education.books"),
            i18n.t("common.category.detail.education.classes"),
            i18n.t("common.category.detail.education.tutoring"),
            i18n.t("common.category.detail.education.toys.kits"),
            i18n.t("common.category.detail.education.institutions"),
          ],
          [i18n.t("common.category.travel.leisure")]: [
            '-',
            i18n.t("common.category.detail.travel.accommodation"),
            i18n.t("common.category.detail.travel.services"),
            i18n.t("common.category.detail.travel.activities"),
            i18n.t("common.category.detail.travel.gear"),
          ],
          [i18n.t("common.category.health.medical")]: [
            '-',
            i18n.t("common.category.detail.health.hospitals"),
            i18n.t("common.category.detail.health.pharmaceuticals"),
            i18n.t("common.category.detail.health.medical.supplies"),
            i18n.t("common.category.detail.health.supplements"),
            i18n.t("common.category.detail.health.wellness.products"),
          ],
          [i18n.t("common.category.life.service")]: [
            '-',
            i18n.t("common.category.detail.services.moving.cleaning"),
            i18n.t("common.category.detail.services.installation.repair"),
            i18n.t("common.category.detail.services.interior.construction"),
            i18n.t("common.category.detail.services.automotive"),
            i18n.t("common.category.detail.services.driving.delivery"),
          ],
          [i18n.t("common.category.hobby.self.improvement")]: [
            '-',
            i18n.t("common.category.detail.hobby.arts.crafts"),
            i18n.t("common.category.detail.hobby.gaming"),
            i18n.t("common.category.detail.hobby.music"),
            i18n.t("common.category.detail.hobby.entertainment"),
            i18n.t("common.category.detail.hobby.stationery"),
          ],
          [i18n.t("common.category.finance.professional")]: [
            '-',
            i18n.t("common.category.detail.finance.insurance"),
            i18n.t("common.category.detail.finance.business"),
            i18n.t("common.category.detail.finance.legal.services"),
            i18n.t("common.category.detail.finance.financial.services"),
          ],
          [i18n.t("common.category.real.estate")]: [
            '-',
            i18n.t("common.category.detail.real.estate.residential"),
            i18n.t("common.category.detail.real.estate.commercial"),
            i18n.t("common.category.detail.real.estate.rental"),
            i18n.t("common.category.detail.real.estate.agencies"),
          ],
          [i18n.t("common.category.baby.kids")]: [
            '-',
            i18n.t("common.category.detail.baby.kids.products"),
            i18n.t("common.category.detail.baby.kids.fashion"),
            i18n.t("common.category.detail.baby.kids.care.services"),
          ],
          [i18n.t("common.category.pet")]: [
            '-',
            i18n.t("common.category.detail.pet.dog.products"),
            i18n.t("common.category.detail.pet.cat.products"),
            i18n.t("common.category.detail.pet.fish.products"),
            i18n.t("common.category.detail.pet.other.products"),
          ],
    }
}

/**
 * @param {{
 *   type?: "tutorial" | "faq" | "notice"
 *   lang: "ko" | "en" | "ja"
 * }} data
 * @returns string
 */

export const GetWordpressUrl = ({ type, lang }) => {
    let baseUrl = "https://support.videomonster.com";
    switch (lang) {
        case "kr":
        case "ko":
            if(type) return `${baseUrl}/ko/${type}`;
            return `${baseUrl}/ko`;

        case "ja":
        case "jp":
            if(type) return `${baseUrl}/ja/${type}-ja`;
            return `${baseUrl}/ja`;

        default:
            if(type) return `${baseUrl}/en/${type}-en`;
            return `${baseUrl}/en`;
    }
}

export const ROUTE_PATH = {
    HOME: '/',
    LOGIN: '/login',
    NAVER_SEARCH: '/naver-search',

    PAYMENT: '/payment',
    GALLERY: '/gallery',
    STUDIO: '/studio',

    WORKSPACE: '/studio/workspace',
    PROJECTS: '/studio/projects',
    FAVORITES: '/studio/favorites',
    AI_TOOLS: '/studio/aitools',
    AI_TOOLS_REMOVE_BACKGROUND: '/studio/aitools/RemoveBackground',
    AI_TOOLS_UPSCALING: '/studio/aitools/Upscaling',
    AI_TOOLS_EXTEND_IMAGE: '/studio/aitools/ExtendImage',
    AI_TOOLS_ERASE_OBJECT: '/studio/aitools/EraseObject',
    AI_TOOLS_GENERATE_COPY: '/studio/aitools/GenerateCopy',
    AI_TOOLS_GENERATE_BACKGROUND_RELIGHT: '/studio/aitools/GenerateBackgroundRelight',
    AI_TOOLS_INPAINT: '/studio/aitools/Inpaint',
    // TO-DO :: 스케치 투 이미지 임시 로직
    AI_TOOLS_SKETCH_TO_IMAGE: '/studio/aitools/SketchToImage',
    
    AI_STUDIO: '/studio/aistudio',
    DESIGN_SELECT: '/studio/designselect',
    
    IMAGE_GENERATION: '/studio/image-generation',
    SKETCH_TO_IMAGE: '/studio/image-generation/sketch-to-image',

    VIDEO_GENERATION: '/studio/video-generation',
    IMAGE_TO_VIDEO: '/studio/video-generation/image-to-video',

    YOUTUBE_SHORTS: '/studio/youtube-shorts',

    MY_VIDEOS: '/user/admin/my-video',
    MY_VIDEOS_SHORTS: '/user/admin/my-video?tab=shorts',
    MY_VIDEOS_TEMPLATE: '/user/admin/my-video?tab=template',
    SHORTS_CUSTOMIZING: '/shorts-customizing',
}

export const MOBILE_ROUTE_PATH = {
    HOME: '/',
    LOGIN: '/login',

    SHOP: '/shop',
    MY_VIDEO: '/myVideo',

    DESIGN_SELECT: '/make',
    DESIGN_SELECT_LIST: '/make/list',

    WORKSPACE: '/workspace',
    AI_TOOLS: '/ai-tool',
    AI_TOOLS_SELECT: '/ai-tool/select',
    AI_TOOLS_REMOVE_BACKGROUND: '/ai-tool/background-remove',
    AI_TOOLS_UPSCALING: '/ai-tool/upscaling',
    AI_TOOLS_EXTEND_IMAGE: '/ai-tool/extend-image',
    AI_TOOLS_ERASE_OBJECT: '/ai-tool/erase-object',
    AI_TOOLS_GENERATE_COPY: '/ai-tool/generate-copy',
    AI_TOOLS_GENERATE_BACKGROUND_RELIGHT: '/ai-tool/change-background',
    AI_TOOLS_INPAINT: '/ai-tool/inpaint',
    AI_TOOLS_SKETCH_TO_IMAGE: '/ai-tool/sketch-to-image',
    AI_TOOLS_IMAGE_TO_VIDEO: '/ai-tool/image-to-video',
    
    MY_VIDEOS_SHORTS: '/myVideo?tab=shorts',
    MY_VIDEOS_TEMPLATE: '/myVideo?tab=template',
    YOUTUBE_SHORTS: '/youtube-shorts',
}

export const MEDIA_SELECT_DIALOG_TAB = {
    WORKSPACE: 'workspace',
    PC_FILE: 'pc_file',
    FREE_STOCK: 'free_stock',
    GETTY_STOCK: 'getty_stock',
}

export const AI_SOURCE_STATE = {
    RENDERING: "Rendering",
    FINISH: 'Finish',
    ERROR: 'Error',
}

export const SHORTS_RENDER_STATE = {
	EMPTY: 'Empty',
	WAITING: 'Waiting',
	RENDERING: 'Rendering',
	FINISH: 'Finish',
	ERROR: 'Error'
}

export const SHORTS_ANALYSIS_STATE = {
	WAITING: 'Waiting',
	DOWNLOADING: 'Downloading',
	READY_TO_ANALYZE: 'ReadyToAnalyze',
	WAIT_TO_ANALYZE: 'WaitToAnalyze',
	ANALYZING: 'Analyzing',
	FINISH: 'Finish',
	ERROR: 'Error'
}

export const SHORTS_ANALYSIS_ANALYSING_STATE = {
    ANALYSIS_START: 1,
    DETECT_LANGUAGE: 2,
    SPEECH_TO_TEXT: 3,
    ANALYZE_TEXT: 4,
    SPLIT_TEXT: 5,
    ANALYSIS_FINISH: 6
}

export const SHORTS_ANALYSIS_ERROR_CODE = {
    ERR_NOT_SUPPORT_LIVE: 'ERR_NOT_SUPPORT_LIVE',
}

export const SHORTS_VIDEO_MIN_DURATION = 180;
export const SHORTS_ANALYSIS_MIN_DURATION = 600;
export const SHORTS_ANALYSIS_MAX_DURATION = 3600;